import ContentMediaContainer from './ContentMediaContainer';

export default ContentMediaContainer;
